// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 163 ? "37e0aedc" : chunkId) + "." + {"163":"eeae0586fc68e939","910":"57f8ea2a96d6219d"}[chunkId] + ".js";
};